module.exports = __webpack_public_path__ + "img/background.d9d62daf.png";